import axios from "../config/axios";

const API_BASE = "/cashbook";

const withHub = (params = {}, locationHubId) => ({
  ...params,
  ...(locationHubId ? { location_hub_id: locationHubId } : {}),
});

export const cashbookService = {
  getReport: (date, locationHubId) =>
    axios.get(`${API_BASE}/report`, {
      params: withHub(date ? { date } : {}, locationHubId),
    }),

  getRange: (fromDate, toDate, locationHubId) =>
    axios.get(`${API_BASE}/range`, {
      params: withHub(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        locationHubId,
      ),
    }),

  getOpeningBalance: () => axios.get(`${API_BASE}/opening-balance`),
  setOpeningBalance: (data) => axios.post(`${API_BASE}/opening-balance`, data),

  createEntry: (data) => axios.post(`${API_BASE}/entries`, data),
  updateEntry: (entryId, data) => axios.put(`${API_BASE}/entries/${entryId}`, data),
  deleteEntry: (entryId) => axios.delete(`${API_BASE}/entries/${entryId}`),

  exportPdf: (fromDate, toDate, locationHubId) =>
    axios.get(`${API_BASE}/export/pdf`, {
      params: withHub(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        locationHubId,
      ),
      responseType: "blob",
    }),

  exportExcel: (fromDate, toDate, locationHubId) =>
    axios.get(`${API_BASE}/export/excel`, {
      params: withHub(
        {
          ...(fromDate && { from_date: fromDate }),
          ...(toDate && { to_date: toDate }),
        },
        locationHubId,
      ),
      responseType: "blob",
    }),
};

export default cashbookService;
